import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import Header from "../../components/Header";
import { Icon } from "@mui/material";
import moment from "moment";
import "moment/locale/id";
import axios from "axios";
import { API_URL } from "../api";
// import CustomModal from "../../components/CustomModal";
import "../css/Kehadiran.css";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export default function Kehadiran() {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isDatePickerVisible, setDatePickerVisibility] = useState(false);
  const [pitUtaraCount, setPitUtaraCount] = useState(0);
  const [pitSelatanCount, setPitSelatanCount] = useState(0);
  const [gisHeadofficeCount, setGisHeadofficeCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [pitSelatanAbsent, setPitSelatanAbsent] = useState(null);
  const [pitUtaraAbsent, setPitUtaraAbsent] = useState(null);
  const [gisHeadofficeAbsent, setGisHeadofficeAbsent] = useState(null);
  const [totalUtara, setTotalUtara] = useState(0);
  const [totalSelatan, setTotalSelatan] = useState(0);
  const [totalGis, setTotalGis] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    type: "info",
    buttons: [],
  });

  moment.locale("id");

  const showModal = (title, message, type = "info", buttons = []) => {
    setModalConfig({ title, message, type, buttons });
    setModalVisible(true);
  };

  const showDatePicker = () => {
    setDatePickerVisibility(true);
  };

  const hideDatePicker = () => {
    setDatePickerVisibility(false);
  };

  const handleConfirm = async (date) => {
    setSelectedDate(date);
    hideDatePicker();
    await fetchAttendanceData(date);
  };

  const fetchTotalPerPit = async () => {
    try {
      const response = await axios.get(`${API_URL}/absensi/total-per-pit`);
      const data = response.data.data || response.data;
      return {
        totalUtara: data.pitUtara || 0,
        totalSelatan: data.pitSelatan || 0,
        totalGis: data.gisHeadoffice || 0,
      };
    } catch (error) {
      console.error("Gagal mengambil data total pekerja:", error);
      showModal("Error", "Gagal mengambil data total pekerja", "error");
      return { totalUtara: 0, totalSelatan: 0, totalGis: 0 };
    }
  };

  const fetchAttendanceData = async (date, totals) => {
    try {
      setLoading(true);

      const formattedDate = moment(date).format("YYYY-MM-DD");
      const response = await axios.get(
        `${API_URL}/absensi/count?date=${formattedDate}`
      );
      const data = response.data.data || response.data;

      if (response.status === 200) {
        const utaraCount = data.pitUtara || 0;
        const selatanCount = data.pitSelatan || 0;
        const gisCount = data.gisHeadoffice || 0;

        setPitUtaraCount(utaraCount);
        setPitSelatanCount(selatanCount);
        setGisHeadofficeCount(gisCount);

        const currentTotals = totals || {
          totalUtara,
          totalSelatan,
          totalGis,
        };

        setPitUtaraAbsent(currentTotals.totalUtara - utaraCount);
        setPitSelatanAbsent(currentTotals.totalSelatan - selatanCount);
        setGisHeadofficeAbsent(currentTotals.totalGis - gisCount);

        if (totals) {
          setTotalUtara(totals.totalUtara);
          setTotalSelatan(totals.totalSelatan);
          setTotalGis(totals.totalGis);
        }
      } else {
        showModal("Terjadi Kesalahan", data.error || "Gagal mengambil data");
      }
    } catch (error) {
      console.error("Error:", error);
      showModal("Koneksi Terputus", "Terjadi kesalahan jaringan", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      try {
        const totals = await fetchTotalPerPit();
        setTotalUtara(totals.totalUtara);
        setTotalSelatan(totals.totalSelatan);
        setTotalGis(totals.totalGis);
        await fetchAttendanceData(selectedDate, totals);
      } catch (error) {
        console.error("Error in initialization:", error);
        setLoading(false);
      }
    };

    initializeData();
  }, []);

  return (
    <div className="kehadiran-container">
      <header className="app-header">
        <div className="header-content">
          <button className="back-button" onClick={() => navigate(-1)}>
            <Icon>arrow_back</Icon>
          </button>
          <h1 className="header-title">Kehadiran P5M</h1>
          <div className="header-spacer"></div> {/* For alignment */}
        </div>
      </header>
      <div className="calendar-button" onClick={showDatePicker}>
        <div className="calendar-content">
          <Icon className="calendar-icon">today</Icon>
          <span className="calendar-date">
            {moment(selectedDate).format("dddd, DD MMMM YYYY")}
          </span>
        </div>
      </div>

      {isDatePickerVisible && (
        <DatePicker
          open={isDatePickerVisible}
          onClose={hideDatePicker}
          value={dayjs(selectedDate)}
          onChange={(newDate) => {
            if (newDate) {
              handleConfirm(newDate.toDate());
            }
            hideDatePicker();
          }}
          maxDate={dayjs()}
          slotProps={{
            textField: { style: { display: "none" } },
          }}
        />
      )}

      <h2 className="kehadiran-title">Jumlah Kehadiran P5M</h2>

      <div className="kehadiran-row">
        <div className="kehadiran-box">
          <h3 className="box-title">Pit Utara</h3>
          {loading ? (
            <div className="loading-spinner"></div>
          ) : (
            <>
              <div className="box-count">{pitUtaraCount}</div>
              <div className="box-label">Orang Hadir</div>
              <div className="box-count absent">
                {pitUtaraAbsent !== null ? pitUtaraAbsent : "-"}
              </div>
              <div className="box-label">Orang Tidak Hadir</div>
            </>
          )}
        </div>

        <div className="kehadiran-box">
          <h3 className="box-title">Pit Selatan</h3>
          {loading ? (
            <div className="loading-spinner"></div>
          ) : (
            <>
              <div className="box-count">{pitSelatanCount}</div>
              <div className="box-label">Orang Hadir</div>
              <div className="box-count absent">
                {pitSelatanAbsent !== null ? pitSelatanAbsent : "-"}
              </div>
              <div className="box-label">Orang Tidak Hadir</div>
            </>
          )}
        </div>
      </div>

      <div className="kehadiran-row single">
        <div className="kehadiran-box">
          <h3 className="box-title">Tim GIS</h3>
          {loading ? (
            <div className="loading-spinner"></div>
          ) : (
            <>
              <div className="box-count">{gisHeadofficeCount}</div>
              <div className="box-label">Orang Hadir</div>
              <div className="box-count absent">
                {gisHeadofficeAbsent !== null ? gisHeadofficeAbsent : "-"}
              </div>
              <div className="box-label">Orang Tidak Hadir</div>
            </>
          )}
        </div>
      </div>

      {/* <CustomModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        title={modalConfig.title}
        message={modalConfig.message}
        type={modalConfig.type}
        buttons={modalConfig.buttons}
      /> */}
    </div>
  );
}
